import { render, staticRenderFns } from "./Zakat_unpaid.vue?vue&type=template&id=534ba82e&scoped=true"
import script from "./Zakat_unpaid.vue?vue&type=script&lang=js"
export * from "./Zakat_unpaid.vue?vue&type=script&lang=js"
import style0 from "./Zakat_unpaid.vue?vue&type=style&index=0&id=534ba82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534ba82e",
  null
  
)

export default component.exports